import Vue from 'vue';
import {i18n} from '@/i18n';
import {err} from './toast';

export default async function getRecaptchaToken(type: string) {
    let token = '';

    await Vue.prototype.$recaptchaLoaded();
    token = await Vue.prototype.$recaptcha(type);

    if (!token) {
        err(i18n.t('ReCaptcha validation failed, please try again').toString());
    }

    return token;
}
